<template>
  <v-container>
    <module-bar :title="title" icon="mdi-tools" />
    <v-row v-if="tool">
      <v-col v-if="employee" cols="12">
        <v-alert type="info" :icon="false">
          <v-row>
            <v-col cols="9">
              <v-avatar>
                <v-img :src="employee.photo_url" :lazy-src="employee.photo_thumb_url" />
              </v-avatar>
              {{ employee.names }} ({{ employee.avatar }})
            </v-col>
            <v-col cols="3" class="d-flex justify-end align-center">
              <v-btn @click="openDialogEmployee" text outlined>ver empleado</v-btn>
            </v-col>
          </v-row>
        </v-alert>
      </v-col>
      <v-col cols="12" v-else class="d-flex justify-end mb-2">
        <v-btn @click="openDialogListEmployee" text color="primary">vincular empleado</v-btn>
      </v-col>
    </v-row>

    <v-card outlined>
      <v-card-text>
        <v-form v-model="valid" ref="formTool">
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field label="Nombre" v-model="name" :rules="rulesName" />
            </v-col>
            <v-col cols="12" md="6">
              <v-select label="Provincia" :items="locations" :rules="rulesLocation" v-model="locationId" item-value="id"
                item-text="name" :loading="loadingLocation" />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field label="Distrito o localidad" v-model="district" :rules="rulesDistrict" />
            </v-col>
            <v-col cols="12">
              <v-textarea outlined label="Descripcion" v-model="description" />
            </v-col>
            <v-col cols="12" md="4">
              <v-file-input label="Foto #1" v-model="photo1" show-size accept="image/png, image/jpeg, image/bmp"
                :rules="rulesPhoto" />
            </v-col>
            <v-col cols="12" md="4">
              <v-file-input label="Foto #2" v-model="photo2" show-size accept="image/png, image/jpeg, image/bmp"
                :rules="rulesPhoto" />
            </v-col>
            <v-col cols="12" md="4">
              <v-file-input label="Foto #3" v-model="photo3" show-size accept="image/png, image/jpeg, image/bmp"
                :rules="rulesPhoto" />
            </v-col>

            <v-col cols="12" md="4" v-if="tool">
              <v-img style="cursor: pointer" v-if="tool.photo_1" width="200" :src="tool.photo_1"
                :lazy-src="tool.photo_1_thumb" aspect-ratio="1" contain class="grey lighten-2"
                @click="openDialogPhoto(tool.photo_1, 1)">
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-col>

            <v-col cols="12" md="4" v-if="tool">
              <v-img style="cursor: pointer" v-if="tool.photo_2" width="200" :src="tool.photo_2"
                :lazy-src="tool.photo_2_thumb" aspect-ratio="1" contain class="grey lighten-2"
                @click="openDialogPhoto(tool.photo_2, 2)">
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-col>

            <v-col cols="12" md="4" v-if="tool">
              <v-img style="cursor: pointer" v-if="tool.photo_3" width="200" :src="tool.photo_3"
                :lazy-src="tool.photo_3_thumb" aspect-ratio="1" contain class="grey lighten-2"
                @click="openDialogPhoto(tool.photo_3, 3)">
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn v-if="schema == 'edit'" text color="red" @click="deleteTool" :loading="loadingDeleteTool"> eliminar
          herramienta</v-btn>
        <v-spacer />
        <v-btn text color="red" v-if="schema == 'edit'" @click="closeDialogTool(null)">cancelar</v-btn>
        <v-btn :loading="loadingProcess" @click="processTool" text color="primary">{{ schema == "new" ? "GUARDAR" :
          "EDITAR"
        }}</v-btn>
      </v-card-actions>
    </v-card>

    <!-- dialogo foto -->
    <v-dialog v-if="tool" v-model="dialogPhoto" width="800">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          <v-img :src="photoSelected" />
        </v-card-text>

        <v-card-actions>
          <v-btn text color="red" @click="deletePhoto" :loading="loadingDeletePhoto">eliminar foto</v-btn>
          <v-spacer />
          <v-btn text @click="closeDialogPhoto">cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialog de empleado vinculado -->
    <v-dialog v-model="dialogEmployee" width="800" persistent v-if="employee">
      <v-card>
        <v-card-title>Empleado vinculado</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" class="d-flex justify-center">
              <v-avatar size="150"><v-img :src="employee.photo_url"
                  :lazy-src="employee.photo_thumb_url"></v-img></v-avatar>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-list>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ tool.employee.names }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      APODO: {{ tool.employee.avatar }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      RESPONSABILIDAD: {{ tool.employee.responsibility }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      RECOMENDADO: {{ tool.employee.recommended }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      SUELDO: {{ tool.employee.salary }} S/
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn text color="red" @click="desvinculeEmployee" :loading="loadingDelete">desvincular de la
            herramienta</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="closeDialogEmployee">cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialog para vincular un empleado -->
    <v-dialog v-model="dialogEmployeeList" width="800">
      <v-card>
        <v-card-text>
          <employee-list :tool="tool" @vinculeEmployeeToolEmit="vinculeEmployeeToolEmit" />
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import ModuleBar from "../General/ModuleBar.vue";
import EmployeeList from "./employeeList.vue";

export default {
  components: { ModuleBar, EmployeeList },
  props: ["schema", "title", "tool", "click"],

  mounted() {
    this.loadLocations();

    this.loadLocations();
    if (this.tool) {
      this.loadTool();
    }
  },

  data() {
    return {
      district: "",
      loadingDelete: false,
      dialogEmployee: false,
      dialogEmployeeList: false,
      locationId: 0,
      loadingLocation: false,
      locations: [],
      dialogPhoto: false,
      loadingDeletePhoto: false,
      valid: false,
      loadingProcess: false,
      name: "",
      description: "",
      photo1: null,
      photo2: null,
      photo3: null,
      photoSelected: "",
      photoNumber: 0,
      loadingDeleteTool: false,

      rulesType: [(value) => (value && value > 0) || "Seleccione el tipo"],
      rulesName: [
        (value) => (value && value.length > 0) || "Ingrese el nombre",
      ],

      rulesLocation: [
        (value) => (value && value > 0) || "Seleccione la ubicacion",
      ],

      rulesDistrict: [
        (value) => (value && value.length > 0) || "Ingrese el distrito o localidad",
      ],

      rulesPhoto: [
        (value) =>
          !value ||
          value.size < 4000000 ||
          "La foto no puede pesar mas de  4 Mb!",
      ],
    };
  },

  computed: {
    employee() {
      if (this.tool) {
        if (this.tool.employee) {
          return this.tool.employee;
        } else {
          return null;
        }
      } else {
        return null;
      }
    },
  },

  watch: {
    click() {
      this.loadTool();
    },

    name(value) {
      this.name = value.toUpperCase();
    },

    district(value) {
      this.district = value.toUpperCase();
    },
  },

  methods: {
    processTool() {
      if (this.valid) {
        this.loadingProcess = true;
        setTimeout(() => {
          let payload = new FormData();

          payload.append("name", this.name);
          payload.append("description", this.description);
          payload.append("photo1", this.photo1);
          payload.append("photo2", this.photo2);
          payload.append("photo3", this.photo3);
          payload.append("location_id", this.locationId);
          payload.append("district", this.district);

          if (this.schema == "edit") payload.append("tool_id", this.tool.id);

          let path =
            this.schema == "new" ? "storeToolAction" : "updateToolAction";

          this.$store
            .dispatch(path, payload)
            .then((res) => {
              this.loadingProcess = false;
              if (this.schema == "edit") this.closeDialogTool(res);
              this.clear();
            })
            .catch(() => {
              this.loadingProcess = false;
            });
        }, 500);
      } else {
        this.$refs.formTool.validate();
      }
    },

    clear() {
      this.name = "";
      this.description = "";
      this.photo1 = null;
      this.photo2 = null;
      this.photo3 = null;
      this.district = "";
      this.$refs.formTool.resetValidation();
    },

    closeDialogTool(data) {
      this.$emit("closeDialogTool", data);
    },

    loadTool() {
      if (this.tool) {
        this.name = this.tool.name;
        this.description = this.tool.description;
        this.locationId = parseInt(this.tool.location_id);
        this.district = this.tool.district || "";
      }
    },

    openDialogPhoto(photo, number) {
      this.dialogPhoto = true;
      this.photoSelected = photo;
      this.photoNumber = number;
    },

    closeDialogPhoto() {
      this.dialogPhoto = false;
      this.photoSelected = "";
    },

    deletePhoto() {
      this.$confirm({
        message: `Quieres eliminar esta foto?`,
        button: {
          no: "No",
          yes: "Si",
        },
        callback: (confirm) => {
          if (confirm) {
            this.loadingDeletePhoto = true;
            setTimeout(() => {
              let payload = {
                photo_number: this.photoNumber,
                tool_id: this.tool.id,
              };

              this.$store
                .dispatch("deletePhotoToolAction", payload)
                .then(() => {
                  this.loadingDeletePhoto = false;
                  this.dialogPhoto = false;
                  this.photoFinish();
                })
                .catch(() => {
                  this.loadingDeletePhoto = false;
                });
            }, 500);
          }
        },
      });
    },

    photoFinish() {
      if (this.photoNumber == 1) {
        this.tool.photo_1 = null;
        this.tool.photo_1_short = null;
        this.tool.photo_1_thumb = null;
        this.tool.photo_1_thumb_short = null;
      }
      if (this.photoNumber == 2) {
        this.tool.photo_2 = null;
        this.tool.photo_2_short = null;
        this.tool.photo_2_thumb = null;
        this.tool.photo_2_thumb_short = null;
      }
      if (this.photoNumber == 3) {
        this.tool.photo_3 = null;
        this.tool.photo_3_short = null;
        this.tool.photo_3_thumb = null;
        this.tool.photo_3_thumb_short = null;
      }
    },

    deleteTool() {
      this.$confirm({
        message: `Quieres eliminar esta herramienta, no podras revertir o recuperar la inforamcion?`,
        button: {
          no: "No",
          yes: "Si",
        },
        callback: (confirm) => {
          if (confirm) {
            this.loadingDeleteTool = true;
            setTimeout(() => {
              this.$store
                .dispatch("deleteToolAction", this.tool.id)
                .then(() => {
                  this.loadingDeleteTool = false;
                  this.tool.is_delete = true;
                  this.closeDialogTool(this.tool);
                })
                .catch(() => {
                  this.loadingDeleteTool = false;
                });
            }, 500);
          }
        },
      });
    },

    loadLocations() {
      this.loadingLocation = true;
      setTimeout(() => {
        this.$store.dispatch("findLocations").then((res) => {
          this.locations = res;
          this.loadingLocation = false;
        });
      }, 500);
    },

    desvinculeEmployee() {
      this.$confirm({
        message: `Quieres desvincular este empleado, no podras recuperar la informacion?`,
        button: {
          no: "No",
          yes: "Si",
        },
        callback: (confirm) => {
          if (confirm) {
            this.loadingDelete = true;

            setTimeout(() => {
              this.$store
                .dispatch("desvinculeEmployeeTool", {
                  tool_id: this.tool.id,
                })
                .then(() => {
                  this.loadingDelete = false;
                  this.dialogEmployee = false;
                  this.tool.employee = null;

                  this.$emit("desvinculeEmployee", {
                    toolId: this.tool.id,
                  });
                });
            }, 5000);
          }
        },
      });
    },

    openDialogEmployee() {
      this.dialogEmployee = true;
    },

    closeDialogEmployee() {
      this.dialogEmployee = false;
    },

    openDialogListEmployee() {
      this.dialogEmployeeList = true;
    },

    closeDialogEmployeeList() {
      this.dialogEmployeeList = false;
    },

    vinculeEmployeeToolEmit({ employee }) {

      this.tool.employee = employee;
      this.dialogEmployeeList = false;

      let data = {
        employee: employee,
        tool_id: this.tool.id,
      };

      this.$emit("vinculeEmployee", data);
    },
  },
};
</script>

<style></style>
